import { useSelector } from 'react-redux';
import { getAuthState } from '../../modules/auth/selectors.js';

/**
 * A hook to return Redux state for auth data
 * @returns {object} Auth data
 * @returns {boolean} `loggedIn` Whether the current user is logged in
 * @returns {string} `accessToken` JWT access token (when logged in using JWT authentication)
 * @returns {string} `refreshToken` JWT refresh token (when logged in using JWT authentication)
 * @returns {number} `expiry` JWT expiry date (when logged in using JWT authentication)
 * @returns {string} `subject` JWT subject claim (when logged in using JWT authentication)
 * @returns {object} `claims` JWT claim data (when logged in using JWT authentication)
 * @returns {object} `identity` JWT data for claims with an 'identity' tag (when logged in using JWT authentication)
 */

var useAuthState = function useAuthState() {
  return useSelector(getAuthState);
};

var useAuthState$1 = useAuthState;

export { useAuthState$1 as default };
